'use strict';

/* eslint no-undef: "off" */
/**
 * XPark discover more
 */
define('xparkDiscoverMore',['swiper', 'xparkHomepageApi', 'svgIcon', 'GAReport'], function (Swiper, xparkHomepageApi, svgIcon, GAReport) {
  return {
    template: '\n      <section class="xp-discover-more" v-if="items.length || loading">\n        <div v-if="loading" class="skeleton-loading"></div>\n        <div v-if="items.length">\n          <h2>Discover More</h2>\n          <div\n            v-if="heroItem && hasVideo(heroItem)"\n            class="xp-discover-hero"\n          >\n            <span class="xp-discover-media">\n              <video\n                :src="heroItem.video"\n                :poster="heroItem.cover_image || \'\'"\n                :title="heroItem.title || \'\'"\n                autoplay\n                muted\n                loop\n                playsinline\n                webkit-playsinline="true"\n                preload="metadata"\n              ></video>\n            </span>\n            <strong v-text="heroItem.title"></strong>\n            <span v-text="heroItem.description"></span>\n          </div>\n\n          <a\n            v-else-if="heroItem"\n            class="xp-discover-hero"\n            :href="getJumpUrl(heroItem)"\n            target="_blank"\n            rel="noopener noreferrer"\n          >\n            <span class="xp-discover-media">\n              <img :src="heroItem.cover_image || \'\'" :alt="heroItem.title || \'\'">\n              <span class="xp-discover-play xp-discover-play-center" aria-hidden="true">\n                <svg-icon type="youtube" width="50" height="50"></svg-icon>\n              </span>\n            </span>\n            <strong v-text="heroItem.title"></strong>\n            <span v-text="heroItem.description"></span>\n          </a>\n\n          <div class="xp-discover-slider-wrap" v-if="sliderItems.length">\n            <div class="xp-discover-slider swiper-container" ref="discoverSwiper">\n              <div class="swiper-wrapper">\n                <template v-for="item in sliderItems">\n                  <div\n                    v-if="hasVideo(item)"\n                    :key="item.title + \'-video\'"\n                    class="xp-discover-card swiper-slide"\n                  >\n                    <span class="xp-discover-card-media">\n                      <video\n                        :src="item.video"\n                        :poster="item.cover_image || \'\'"\n                        :title="item.title || \'\'"\n                        autoplay\n                        muted\n                        loop\n                        playsinline\n                        webkit-playsinline="true"\n                        preload="metadata"\n                      ></video>\n                    </span>\n                    <strong v-text="item.title"></strong>\n                    <span v-text="item.description"></span>\n                  </div>\n\n                  <a\n                    v-else\n                    :key="item.title + \'-jump\'"\n                    class="xp-discover-card swiper-slide"\n                    :href="getJumpUrl(item)"\n                    target="_blank"\n                    rel="noopener noreferrer"\n                    @click="handleGA(item.title)"\n                  >\n                    <span class="xp-discover-card-media">\n                      <img :src="item.cover_image || \'\'" :alt="item.title || \'\'">\n                      <span class="xp-discover-play xp-discover-play-corner" aria-hidden="true">\n                        <svg-icon type="youtube" width="36" height="36"></svg-icon>\n                      </span>\n                    </span>\n                    <strong v-text="item.title"></strong>\n                    <span v-text="item.description"></span>\n                  </a>\n                </template>\n              </div>\n            </div>\n          </div>\n        </div>\n      </section>\n    ',
    components: {
      svgIcon: svgIcon
    },
    data: function data() {
      return {
        discoverSlider: null,
        discoverSliderTimer: null,
        items: [],
        loading: false
      };
    },

    computed: {
      heroItem: function heroItem() {
        return this.items[0] || null;
      },
      sliderItems: function sliderItems() {
        return this.items.slice(1);
      }
    },
    mounted: function mounted() {
      this.fetchDiscoverMore();
    },
    beforeDestroy: function beforeDestroy() {
      if (this.discoverSliderTimer) {
        window.clearTimeout(this.discoverSliderTimer);
      }

      if (this.discoverSlider && this.discoverSlider.destroy) {
        this.discoverSlider.destroy(true, true);
      }
    },

    methods: {
      hasVideo: function hasVideo(item) {
        return !!(item && item.video);
      },
      getJumpUrl: function getJumpUrl(item) {
        return item && item.youtube_link_url || 'javascript:void(0);';
      },
      fetchDiscoverMore: function fetchDiscoverMore() {
        var _this = this;

        this.loading = true;
        xparkHomepageApi.getDiscoverMore().then(function (data) {
          var list = data && data.discover_more_list;

          if (!Array.isArray(list) || !list.length) {
            return;
          }

          _this.items = list;

          _this.$nextTick(_this.resetDiscoverSlider);
        }).catch(function () {}).finally(function () {
          return _this.loading = false;
        });
      },
      resetDiscoverSlider: function resetDiscoverSlider() {
        if (this.discoverSliderTimer) {
          window.clearTimeout(this.discoverSliderTimer);
          this.discoverSliderTimer = null;
        }

        if (this.discoverSlider && this.discoverSlider.destroy) {
          this.discoverSlider.destroy(true, true);
          this.discoverSlider = null;
        }

        this.initDiscoverSlider();
      },
      initDiscoverSlider: function initDiscoverSlider() {
        var _this2 = this;

        var container = this.$refs.discoverSwiper;

        if (!container || this.sliderItems.length < 2) {
          return;
        }

        this.discoverSliderTimer = window.setTimeout(function () {
          _this2.discoverSlider = new Swiper(container, {
            centeredSlides: true,
            loop: true,
            loopAdditionalSlides: _this2.sliderItems.length,
            loopedSlides: _this2.sliderItems.length,
            observer: true,
            observeParents: true,
            slidesPerView: 'auto',
            spaceBetween: 12,
            speed: 350
          });
        }, 20);
      },
      handleGA: function handleGA(action) {
        new GAReport().customerClick({
          eventAction: action,
          eventCategory: 'DISCOVER_MORE_#VERSION#'
        });
      }
    }
  };
});
